<template>
  <div>

    <menu-idiomas></menu-idiomas>

    <menu-servicios></menu-servicios>

    <search-bar></search-bar>

    <br>

    <menu-productos></menu-productos>
    
    
    <router-view></router-view>

    
    <menu-footer></menu-footer>

    <usuario-login></usuario-login>

    <check-user-and-reload></check-user-and-reload>

  </div>
</template>

<script>
  import {mapState} from 'vuex'

  import MenuIdiomas from '@/components/MenuIdiomas.vue'
  import MenuServicios from '@/components/MenuServicios.vue'
  import SearchBar from '@/components/SearchBar.vue'
  import MenuProductos from '@/components/MenuProductos.vue'
  import MenuFooter from '@/components/MenuFooter.vue'

  import UsuarioLogin from '@/components/UsuarioLogin.vue'

  import CheckUserAndReload from '@/components/usuario/CheckUserAndReload.vue'

  export default {
    components: { MenuIdiomas, MenuServicios, SearchBar, MenuProductos, MenuFooter, UsuarioLogin, CheckUserAndReload},
  }
  
</script>